import spiceGirlsImg from "../..//resources/spiceGirls.jpg";
import pjHarveyImg from "../..//resources/pjHarvey.jpg";
import duaLipaImg from "../..//resources/duaLipa.jpg";
import abbaImg from "../..//resources/abba.jpg";

const spiceGirls = {
    name: 'Spice Girls',
    ref: "0uq5PttqEjj3IH1bzwcrXF",
    image: spiceGirlsImg
}
const pjHarvey = {
    name: 'PJ Harvey',
    ref: "12VaqyEhgwDRuFfEqbnrpz",
    image: pjHarveyImg
}
const duaLipa = {
    name: 'Dua Lipa',
    ref: "6M2wZ9GZgrQXHCFfjv46we",
    image: duaLipaImg
}
const abba = {
    name: 'Abba',
    ref: "0LcJLqbBmaGUft1e9Mm8HV",
    image: abbaImg
}

const targetArtist = [spiceGirls, pjHarvey, duaLipa, abba];

export default targetArtist;